import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7a909d43: FaireBrandEntity = {
  token: "b_7a909d43",
  type: "brand",
  name: "Simon & Schuster",
  avatarUrl:
    "https://cdn.faire.com/fastly/6d568b4dc3731810901353ed70eb7169ec50ba4e2820efbe21c1ac316c950bc8.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/132e13a682c7a2d737476b170f2195c1e77df407d02c58a73a16ac2c19c456e0.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6d568b4dc3731810901353ed70eb7169ec50ba4e2820efbe21c1ac316c950bc8.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/132e13a682c7a2d737476b170f2195c1e77df407d02c58a73a16ac2c19c456e0.jpeg",
  location: "New York City, NY, USA",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 898,
  isInsider: true,
  description:
    "Simon & Schuster is a leading international publisher dedicated to sharing a broad range of works that educate, entertain, and inspire readers of all ages. We publish books that represent many perspectives, to stimulate readers’ curiosity and intellectual exploration, and have the capacity to both inform and challenge our views, and to create change in the world. Our passionate commitment to excellence in all aspects of publishing is reflected in our unceasing effort to bring our authors’ works to the widest possible audience.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:47.233Z",
    importedBy: "entity-db-cli",
  },
};
